import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.scss';

// date can be displayed as [November 21, 2020 at 6:58 AM] or [November 21, 2020]
const showDate = (timestampFormat, displayDateAtTime, displayDate) => {
  if (timestampFormat === 'date_at_time') {
    return <time data-testid="date_at_time">{displayDateAtTime}</time>;
  }
  return <time data-testid="date">{displayDate}</time>;
};

const showLocation = (location) =>
  location ? (
    <div data-testid="location" className={styles.location}>
      <span>&nbsp;</span>
      {`· ${location}`}
    </div>
  ) : (
    ''
  );

const Subtitle = ({
  timestampFormat,
  displayDateAtTime,
  displayDate,
  location
}) => (
  <div
    className={`text-caption1 ${styles.subtitleWrapper}`}
    data-testid="subtitle_wrapper"
  >
    {showDate(timestampFormat, displayDateAtTime, displayDate)}
    {showLocation(location)}
  </div>
);

Subtitle.propTypes = {
  timestampFormat: PropTypes.string,
  displayDateAtTime: PropTypes.string.isRequired,
  displayDate: PropTypes.string.isRequired,
  location: PropTypes.string
};

Subtitle.defaultProps = {
  timestampFormat: 'date',
  location: null
};

export default Subtitle;
